import { useQuery } from "@tanstack/react-query";
import { LoaderCircle } from "lucide-react";
import {
  Navigate,
  Outlet,
  useLocation
} from "react-router";

import { getCurrentAdmin } from "../../services/auth";

export function RequireAdmin() {
  const location = useLocation();

  const adminQuery = useQuery({
    queryKey: ["admin", "me"],
    queryFn: getCurrentAdmin,
    retry: false,
    staleTime: 5 * 60 * 1000
  });

  if (adminQuery.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f7f4ef]">
        <div className="text-center">
          <LoaderCircle
            className="mx-auto animate-spin text-[#5e3b2c]"
            size={38}
          />

          <p className="mt-4 text-sm font-medium text-[#746d65]">
            Verifying administrator session
          </p>
        </div>
      </div>
    );
  }

  if (
    adminQuery.isError ||
    !adminQuery.data
  ) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{
          from: location.pathname
        }}
      />
    );
  }

  return <Outlet />;
}
